export const initState = {
  token: null,
  user: null,
  isLogedIn: false,
};

export const bookInitState = {
  books: [],
};

export const cartInitState = {
  items: [],
  totalPrice: 0,
  quantity: 0,
};
